export const API_ENDPOINTS = {
  getTeamMembers: "/teams",
  getFaq: "/faqs",
  getCareers: "/careerS",
  getVideos: "/videos",
  getEquipments: "/equipments",
  submitIdea: "/ideas",
  socials: "/socials",
};
